import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, money } from "@/lib/api";
import { TID } from "@/lib/testIds";

const STATUSES = ["", "unfulfilled", "processing", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    http.get(`/admin/orders${status ? `?status=${status}` : ""}`).then((r) => setOrders(r.data));
  }, [status]);

  return (
    <div>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold">Orders</h1>
          <p className="text-white/45 text-sm mt-1">{orders.length} orders</p>
        </div>
        <div className="flex gap-2">
          {STATUSES.map((s) => (
            <button
              key={s || "all"}
              onClick={() => setStatus(s)}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold ${status === s ? "bg-[#7f77dd] text-white" : "bg-[#1d1d2e] text-white/55 hover:text-white"}`}
              data-testid={`orders-filter-${s || "all"}`}
            >
              {s || "all"}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 bls-admin-card overflow-hidden">
        <table className="w-full">
          <thead>
            <tr>
              <th className="bls-admin-th">Order</th>
              <th className="bls-admin-th">Customer</th>
              <th className="bls-admin-th">Payment</th>
              <th className="bls-admin-th">Status</th>
              <th className="bls-admin-th">Total</th>
              <th className="bls-admin-th">Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 && (
              <tr><td colSpan={6} className="bls-admin-td text-center text-white/45">No orders yet</td></tr>
            )}
            {orders.map((o) => (
              <tr key={o.id} className="bls-admin-tr cursor-pointer" data-testid={`${TID.adminOrderRow}-${o.order_number}`}>
                <td className="bls-admin-td">
                  <Link to={`/admin/orders/${o.id}`} className="font-mono font-semibold hover:text-[#7f77dd]">{o.order_number}</Link>
                  <p className="text-xs text-white/40 mt-1">{o.items?.length || 0} items</p>
                </td>
                <td className="bls-admin-td">
                  <p className="font-medium">{o.address?.full_name}</p>
                  <p className="text-xs text-white/40">{o.email}</p>
                </td>
                <td className="bls-admin-td">
                  <span className="capitalize">{o.payment_method}</span>
                  <span className={`ml-2 bls-status bls-status-${o.payment_status}`}>{o.payment_status}</span>
                </td>
                <td className="bls-admin-td">
                  <span className={`bls-status bls-status-${o.fulfillment_status}`}>{o.fulfillment_status}</span>
                </td>
                <td className="bls-admin-td font-mono">{money(o.total)}</td>
                <td className="bls-admin-td text-xs text-white/55">{new Date(o.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
